__turbopack_context__.v({
  "productArticleCard": "product-article-card-module-scss-module__jMLooa__productArticleCard",
  "productArticleCardContent": "product-article-card-module-scss-module__jMLooa__productArticleCardContent",
  "productArticleCardDescription": "product-article-card-module-scss-module__jMLooa__productArticleCardDescription",
  "productArticleCardImage": "product-article-card-module-scss-module__jMLooa__productArticleCardImage",
  "productArticleCardInfo": "product-article-card-module-scss-module__jMLooa__productArticleCardInfo",
  "productArticleCardInfoCategory": "product-article-card-module-scss-module__jMLooa__productArticleCardInfoCategory",
  "productArticleCardInfoSeparator": "product-article-card-module-scss-module__jMLooa__productArticleCardInfoSeparator",
  "productArticleCardLink": "product-article-card-module-scss-module__jMLooa__productArticleCardLink",
  "productArticleCardTitle": "product-article-card-module-scss-module__jMLooa__productArticleCardTitle",
  "secondary": "product-article-card-module-scss-module__jMLooa__secondary",
});
